/**
 * Junta classes condicionais.
 *
 * Mora sozinho, e nao dentro do `ui.tsx`, porque o `Select` tambem precisa
 * dele: importar de `ui.js` de la fecharia um ciclo com o re-export que o
 * `ui.tsx` faz do proprio Select.
 */
export function cx(...values: Array<string | false | null | undefined>): string {
  return values.filter(Boolean).join(' ');
}
